import { PropsWithChildren } from "react"
import styled from "styled-components"

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const Description = ({ children }: PropsWithChildren<{}>) => {
  return <DescriptionContainer>{Array.isArray(children) ? children.map((c) => c) : children}</DescriptionContainer>
}
